<div class="card">
    @if (showHeader) {
        <div class="card-header">
            <h3 class="card-title">Payment details</h3>
        </div>
    }
    <div class="card-body"
         *adaptLoadingUntilFirstEmit="let account of account$">
        @if (!account?.extensions?.isActive && !account?.extensions?.isTrial) {
            @if (!account?.extensions?.isPendingCancellation) {
                <p>Your organisation's subscription status is currently not active.</p>
            }
            @if (account?.extensions?.isPendingCancellation) {
                <p>
                    You have cancelled your subscription for
                    {{ AdaptProjectLabel }}.
                </p>
                <p>
                    Your subscription ends on
                    <strong>{{ account?.nextSubscriptionInvoiceDate | adaptDate }}</strong>.
                </p>
                <p>After this date, your organisation will be in a read-only state, and you can log in at any time to retrieve your data.
                    You may resume your subscription at any time, you will not be charged again until the above date.</p>
            }
            <button class="btn btn-primary"
                    (click)="showUpdateInvoicePaymentMethodDialog(account)">
                {{ getSubscriptionButtonText(account) }}
            </button>
        } @else {
            @if (account && account.extensions.isBilledUsingCreditCard) {
                <adapt-configure-credit-card [organisationId]="account.organisationId"></adapt-configure-credit-card>
            }
            @if (account && !account.extensions.isBilledUsingCreditCard) {
                <p>Your organisation is being invoiced.</p>
                <button class="btn btn-primary"
                        (click)="showUpdateInvoicePaymentMethodDialog(account)">Update payment method</button>
            }
        }
    </div>
</div>
